export const API_CONSTANTS = {
    SUCCESS : "SUCCESS",
    FAILURE: "FAILURE",
    UNAUTHORIZED: "unauthorized",
    TIMEOUT:"timeout",
    NO_CONNECTION:"no connection",
    SERVER_ERROR:"Unknown Error - Server may be down"
}

export const REPORT_TYPE = {
    CLAIMS: 1,
    MEMBER_DETAILS: 2
}

export const TRANSACTION_TYPES = {
    PREMIUM : 1,
    CLAIM : 2,
    INCOME : 3,
    EXPENSE : 4
}

export const ROLES = {
    DEV: 1,
    ADMIN: 2,
    COORD: 3
}